import React, { useMemo } from 'react';
import { Progress, Rate } from 'tea-component';
import { reviewsFormat, scoreFormat } from '@op/utils/value';
import ChannelLabel from '@op/components/ChannelLabel';
import { useIntl } from 'umi';
import classNames from 'classnames';
import './index.scss';

const channelMapItem: any = {
  xbox: 'lifetime',
  ps: 'lifetime',
  metacritic: 'meta_score',
  opencritic: 'top_critic_average',
};

export default function Ratings({ data }: any) {
  const { formatMessage } = useIntl();
  function dealwithOpencritic(
    list = [],
    channel: string,
    renderKey: string = 'top_critic_average',
  ) {
    const item = list.find((it: any) => it.key === renderKey);
    return {
      channel,
      review: 0,
      score: 0,
      ...(item || {}),
    };
  }

  const renderList = useMemo(() => {
    const keys = Object.keys(data);
    const infoList = keys.reduce((pre: Array<any>, key: string) => {
      const list = data[key];
      const obj = dealwithOpencritic(list, key, channelMapItem[key]);
      if (obj.review === 0 && obj.score === 0) return pre;
      return [...pre, obj];
    }, []);

    const sortItems = Object.keys(channelMapItem);
    infoList.sort(
      (a, b) => sortItems.indexOf(a.channel) - sortItems.indexOf(b.channel),
    );

    return infoList;
  }, [data]);

  // console.log(renderList, 'renderList');

  return (
    <div className="dbh-gamestore-ratings">
      {renderList.map((item) => {
        return ['metacritic', 'opencritic'].includes(item.channel) ? (
          <CriticElement
            {...item}
            formatMessage={formatMessage}
            className={`max-card-${renderList.length}`}
          ></CriticElement>
        ) : (
          <StarElement {...item} formatMessage={formatMessage}></StarElement>
        );
      })}
    </div>
  );
}

function StarElement({ review, score, channel, formatMessage }: any) {
  return (
    <div className="gamestore-ratings-card">
      <div className="gamestore-ratings-card-content">
        <div className="gamestore-ratings-card-img">
          <ChannelLabel channel_name={channel} showText={false}></ChannelLabel>
        </div>
        <div className="gamestore-ratings-card-value star-value">
          {scoreFormat(score, 2, '0')}
        </div>
      </div>
      <div className="dbh-scorebox-reviewbox">
        <Rate
          readonly
          allowHalf
          theme="primary"
          defaultValue={score}
          size="m"
        />
        <div className="bubble-common-child-wrapper no-pointer">
          <div className="dbh-scorebox-text">
            {reviewsFormat(review, 2, '0')} {formatMessage({ id: 'Reviews-1' })}
          </div>
        </div>
      </div>
    </div>
  );
}

function CriticElement({ review, score, channel, formatMessage, className }: any) {
  const text = channel === 'metacritic' ? 'Meta Score' : 'Top Critic Avg';

  return (
    <div className={classNames(className, "gamestore-ratings-critic-card")} >
      <div className="gamestore-ratings-critic-card-content">
        <div className="gamestore-ratings-critic-card-img">
          <ChannelLabel channel_name={channel}></ChannelLabel>
        </div>
        <div className="bubble-common-child-wrapper no-pointer">
          <div className="dbh-scorebox-text">{text}</div>
          <div className="dbh-scorebox-text">
            {reviewsFormat(review, 2, '0')} {formatMessage({ id: 'Reviews-1' })}
          </div>
        </div>
      </div>
      <div className="dbh-scorebox-reviewbox">
        <div className="dbh-scorebox-reviewbox-value">
          <Progress
            theme="default"
            type="circle"
            text={score}
            percent={score}
            strokeColor="#326FF0"
            strokeWidth={5}
            width={60}
          />
        </div>
      </div>
    </div>
  );
}
